import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

const CHAT_CALLABLE_TIMEOUT_MS = 150_000;

export type ChatWithInvestmentCaseResponse = {
  userMessageId: string;
  assistantMessageId: string;
  reply: string;
};

export function chatWithInvestmentCaseErrorMessage(err: unknown): string {
  if (err && typeof err === 'object' && 'code' in err) {
    const code = String((err as { code: string }).code);
    if (code === 'functions/invalid-argument') {
      return 'Enter a shorter message and try again.';
    }
    if (code === 'functions/unauthenticated') {
      return 'Sign in to chat about this deal.';
    }
    if (code === 'functions/not-found') {
      return 'This investment case could not be found.';
    }
    if (code === 'functions/unavailable') {
      return 'Chat is temporarily unavailable. Try again in a moment.';
    }
    if (code === 'functions/deadline-exceeded') {
      return 'The reply timed out. Try again in a moment.';
    }
  }
  if (err && typeof err === 'object' && 'message' in err) {
    const message = String((err as { message: string }).message);
    if (message && !message.startsWith('Firebase')) {
      return message;
    }
  }
  return err instanceof Error ? err.message : 'Could not send the message.';
}

export async function chatWithInvestmentCase(
  caseId: string,
  message: string,
  threadId?: string
): Promise<ChatWithInvestmentCaseResponse> {
  const fn = httpsCallable<
    { caseId: string; message: string; threadId?: string },
    ChatWithInvestmentCaseResponse
  >(functions, 'chatWithInvestmentCase', { timeout: CHAT_CALLABLE_TIMEOUT_MS });
  return (
    await fn({
      caseId: caseId.trim(),
      message: message.trim(),
      ...(threadId ? { threadId: threadId.trim() } : {}),
    })
  ).data;
}
